import { connect } from 'react-redux'
import BranchesList from './BranchesList'
import * as actions from '../../redux/organisations'

const mapStateToProps = (state) => ({
  branches: state.organisations.branches,
  orgID: state.authentication.orgID
})

export default connect(mapStateToProps, actions)(BranchesList)
